import { SelectField } from './select-field';
import { FieldTypeE } from '../types';
import { TextField } from './text-field';

export const FIELDS = {
  [FieldTypeE.Text]: TextField,
  [FieldTypeE.Select]: SelectField,
} as const;
